import { createContext } from 'react';
import { GearNotificationProps } from '../../components/common/GearNotification';
import { NotificationCenterItem } from './NotificationCenterItem';

export interface INotificationContext {
  showToast: (props: Omit<GearNotificationProps, 'show'>) => void;
  centerNotifications: NotificationCenterItem[];
  addCenterNotification: (notification: NotificationCenterItem) => void;
  updateCenterNotification: (notificationId: string, updates: Partial<NotificationCenterItem>) => void;
  removeCenterNotification: (notificationId: string) => void;
  markAllAsRead: () => void;
  clearAllCenterNotifications: () => void;
  unreadCenterCount: number;
}

export const NotificationContext = createContext<INotificationContext | undefined>(undefined);
